import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Relative } from 'src/app/models/Relative';

@Component({
  selector: 'app-node',
  templateUrl: './node.component.html',
  styleUrls: ['./node.component.scss'],
})
export class NodeComponent implements OnInit {

  @Input() rel: Relative = new Relative();
  @Output() clickRel: EventEmitter<Relative> = new EventEmitter();
  constructor() { }

  ngOnInit() { }



}
